import React, { useState, useContext, useEffect } from "react";
import { AppContext, useAppContext } from "../Contexts/AppContext";
import DeliveryAddress from "../Components/DeliveryAddress";
import DeliverySelect from "../Components/DeliverySelect";
import VerifyStock from "../Components/VerifyStock";
import Payment from "../Components/Payment";
import PaymentSuccess from "../Components/PaymentSuccess";
import { usePageTitle } from "../Utilities/usePageTitle";


const Checkout = () => {
    usePageTitle('תשלום');

    const { customer } = useContext(AppContext);
    const { setShowLoginModal } = useAppContext();
    const [ component, setComponent ] = useState('DeliveryAddress');
    const [ data, setData ] = useState('');
    const [ yishuv, setYishuv] = useState('');

    useEffect(() => {

        if (customer == null) {
            setShowLoginModal(true);
            return;
        }

        setData({
            phoneNo: customer.customerPhone ?? customer.phoneNo,
            yishuvId: customer.yishuvId,
            address: customer.address,
            entrance: customer.entrance,
            intercom: customer.intercom,
            notes: customer.notes
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customer])


    return (

        <div className="container ">
            <div className="wrapper checkout">
                <div className="m-1">
                { 
                    {
                    'DeliveryAddress':
                        <DeliveryAddress data={data} setData={setData} setComponent={setComponent} setYishuv={setYishuv}/>,
                    'DeliverySelect':
                        <DeliverySelect  data={data} setData={setData} setComponent={setComponent}/>,
                    'VerifyStock':
                        <VerifyStock  data={data} setData={setData} setComponent={setComponent}  yishuv={yishuv}/>,
                    'Payment':
                        <Payment data={data} setComponent={setComponent} />,
                    'PaymentSuccess':
                        <PaymentSuccess data={data} setComponent={setComponent} />
                    }[component]
                }
                </div>
            </div>
        </div>
    )  
}


export default Checkout;
